import { createFileRoute } from '@tanstack/react-router'
import { TypesImportPage } from '../../../components/TypesImportPage'

export const Route = createFileRoute('/$org/types/import')({
  component: TypesImport,
})

function TypesImport() {
  return <TypesImportPage />
}
